import { Module } from 'vuex'
import actions from './actions'
import mutations from './mutations';
import RootState from '@vue-storefront/core/types/RootState';
import LanguagesState from '../types/LanguagesState';
import config from 'config'

export const module: Module<LanguagesState, RootState> = {
  namespaced: true,
  state: {
    languages: config.i18n.availableLocale,
    currentLanguage: ''
  },
  actions,
  mutations
}
